var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"easter-test container"},[(!_vm.participantId)?_c('EasterSignupForm'):[_c('EasterEgg')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }